import styled, { breakpoints } from '../../../styles/theme';
import HeaderStyled from '../HeaderStyled';
import { rem } from 'polished';

export const HeaderStyledDS = styled(HeaderStyled)`
    background: ${({ theme }) => theme.colors.headerBackground};
    padding: 0 ${rem('15px')};
    height: ${rem(60)};

    @media (min-width: ${breakpoints.sm}px) {
        padding: 0 ${rem('28px')};
        height: ${rem(80)};
    }

    .header-container {
        height: ${rem('48px')};

        @media (min-width: ${breakpoints.sm}px) {
            justify-content: space-between;
            height: ${rem('80px')};
        }
    }

    .main-section {
        align-items: center;
    }

    .header-logo-icon {
        margin-right: 1rem;

        @media (min-width: ${breakpoints.sm}px) {
            margin-right: 0;
            width: ${rem('89px')};

            svg {
                width: ${rem('89px')};
            }
        }
    }

    .link-section {
        a {
            padding: 0px 0.625rem 0.875rem;
            margin-bottom: ${rem('-5px')};
            color: ${({ theme }) => theme.colors.white};
            border: none;

            &:hover {
                color: ${({ theme }) => theme.colors.white};
                padding: 0px 0.625rem 0.575rem;
                border-bottom: 0.3rem solid ${({ theme }) => theme.colors.white};
            }
        }
    }

    .title-section {
        margin: 0;
        padding: 0;
        padding-left: 1rem;
        border-left: 1px solid ${({ theme }) => theme.colors.champagne1};
        align-self: stretch;
        margin-top: ${rem('5px')};
        margin-bottom: ${rem('5px')};

        @media (max-width: ${breakpoints.xs}px) {
            padding-left: 0.5rem;
        }

        @media (min-width: ${breakpoints.sm}px) {
            margin-left: 1rem;
            padding: 0 1rem;
        }

        .title-primary {
            font-size: ${rem('16px')};
            color: ${({ theme }) => theme.colors.secondary};

            span {
                color: ${({ theme }) => theme.colors.white};
            }

          .pro-label-b2b {
            color: ${({ theme }) => theme.colors.lozenge};
          }

            @media (max-width: ${breakpoints.xs}px) {
                font-size: ${rem('11px')};
                letter-spacing: ${rem('0.4px')};
            }

            @media (min-width: ${breakpoints.sm}px) {
                font-size: ${rem('32px')};
                display: block;
            }
        }

        .title-secondary {
            font-size: ${rem('11px')};
            color: ${({ theme }) => theme.colors.grey2};

            @media (max-width ${breakpoints.md}px) {
                margin-top: 0;
                line-height: 1;
            }

            @media (min-width: ${breakpoints.md}px) {
                display: block;
                font-size: ${rem('16px')};
            }
        }
    }

    .navigation {
        padding-top: ${rem('10px')};
        align-self: flex-start;
        display: flex;
        position: relative;

        @media (max-width: ${breakpoints.sm}px) {
            padding-top: ${rem('2px')};
        }

        a {
            flex-direction: row-reverse;
            margin-left: 1rem;

            > p {
                color: ${({ theme }) => theme.colors.grey4};
                font-size: ${rem('12px')};

                @media (max-width: ${breakpoints.sm}px) {
                    display: none;
                }
            }
        }

        .need-help-section {
            top: ${rem(115)};

            @media (min-width: ${breakpoints.md}px) {
                top: ${rem(45)};
            }
        }

        .need-help-link .icon-wrapper {
            margin-top: -${rem(3)} !important;
        }

        .header__nav-description_secondary {
            color: ${({ theme }) => theme.colors.primary};
        }

        .need-help-open {
            background: unset;
            color: ${({ theme }) => theme.colors.black1};

            @media (min-width: ${breakpoints.md}px) {
                background: ${({ theme }) => theme.colors.white};
            }
        }

        .isLoggedOut {
            path {
                fill: ${({ theme }) => theme.colors.white} !important;
            }
        }

        .isLogged {
            background: ${({ theme }) => theme.colors.white};
        }

      .link-wrapper {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        
        .storeCar {
          height: ${rem('26px')};
          width: ${rem('26px')};

          
          svg {
                height: ${rem('26px')};
                width: ${rem('26px')};
                margin-left: ${rem('7px')};
            }
          
          path {
            fill: ${({ theme }) => theme.colors.white};
          }
        } 
      }
      
      .link-wrapper-b2c {
        flex-direction: row-reverse;
        .storeCar > svg {
          margin-left: ${rem('7px')};
        }
      }
      
        .account {
            height: ${rem('20px')};
            width: ${rem('22px')};

            svg {
                transform: translate(${rem('2px')}, ${rem('2px')});
                height: ${rem('14px')};
                width: ${rem('14px')};
                margin: ${rem('1px')} ${rem('2px')};
            }

            path {
                fill: ${({ theme }) => theme.colors.primary};
            }

            @media (min-width: ${breakpoints.sm}px) {
                margin-left: 0.65rem;
            }
        }

        .basket {
            svg {
                margin-top: 0.3rem;
                height: ${rem('14px')};
                width: ${rem('18px')};
            }

            @media (min-width: ${breakpoints.sm}px) {
                margin-left: 0.5rem;
            }
        }

        .logoutBox {
            right: ${rem('27px')};

            svg {
                height: ${rem('14px')};
                width: ${rem('14px')};

                path {
                    fill: ${({ theme }) => theme.colors.coffeeSpilled};
                }
            }

            .logoutButton {
                border: 1px solid ${({ theme }) => theme.colors.primary};
            }

            .accountStatement {
                border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
            }
        }
    }
`;
